var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8332 23.0829V24.9996C45.8306 29.4921 44.3759 33.8635 41.6859 37.4617C38.996 41.0599 35.215 43.6922 30.9068 44.966C26.5987 46.2398 21.9941 46.0868 17.78 44.5299C13.5658 42.973 9.96787 40.0956 7.52267 36.3268C5.07748 32.558 3.91607 28.0997 4.21166 23.6169C4.50726 19.1341 6.24402 14.8669 9.16292 11.4518C12.0818 8.03668 16.0265 5.6566 20.4086 4.66653C24.7907 3.67645 29.3754 4.12942 33.479 5.95789M45.8332 8.33289L24.9998 29.1871L18.7498 22.9371",
    stroke: "#1EA939",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.a3029787a57ea7ca3ca449bd2729aeef.svg";
export { ForwardRef as ReactComponent };